import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import { FOOTER_HEIGHT } from "../../MobileWorkOrderOverlay/styles";

export default makeStyles((theme: MuiTheme) => ({
  tableContent: {
    top: 48,
    bottom: 0,
    position: "absolute",
    overflowY: "auto",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      paddingBottom: FOOTER_HEIGHT,
      position: "relative",
      top: 0
    }
  },
  tableContentNoPadding: {
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 0
    }
  },
  tableRow: {
    padding: "8px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&:nth-child(n)": {
      background: "rgba(238, 238, 238, 0.5)"
    },
    "&:nth-child(2n)": {
      background: "rgba(238, 238, 238, 0)"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "15px 16px"
    }
  },
  dividerRow: {
    borderBottom: `1px solid ${theme.palette.text.hint}`
  },
  column: {
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      padding: "4px 16px"
    }
  },
  tableCell: {
    border: "none",
    color: theme.palette.text.secondary,
    fontSize: 13,
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      alignItems: "center",
      fontSize: 14
    }
  },
  cursive: {
    fontStyle: "italic"
  },
  capitalize: {
    textTransform: "capitalize"
  },
  rightCell: {
    color: theme.palette.text.primary,
    textAlign: "right"
  },
  shrinkLabelCell: {
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 4,
      minHeight: 46
    }
  },
  descriptionText: {
    marginTop: 8,
    wordBreak: "break-word",
    fontSize: 12,
    color: theme.palette.text.primary,
    paddingTop: 0,
    wordWrap: "break-word",
    display: "block",
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 16,
      fontSize: 13,
      marginTop: 0
    }
  },
  notesText: {
    marginTop: 8,
    fontSize: 12,
    color: theme.palette.text.hint,
    paddingTop: 0,
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 16,
      fontSize: 13,
      marginTop: 0
    }
  },
  wrench: {
    fontSize: 12,
    marginRight: 6
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_OPEN}`]: {
    color: "#f47844"
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_ASSIGNED}`]: {
    color: "#4269B5"
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CANCELED}`]: {
    color: theme.palette.text.secondary
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CLOSED}`]: {
    color: theme.palette.secondary.dark
  },
  [`status-${racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_COMPLETE}`]: {
    color: theme.palette.secondary.dark
  }
}));
